import React from "react";
import { Col, Container, ListGroup, Row } from "react-bootstrap";
import Header from "../stories/components/Header.js";
import LinkListItem from "../stories/components/LinkListItem";
import Image from "../stories/components/Image.js";

import LilleRiksvapenImage from "../assets/Lille-riksvapen.png";
import PrimarlogoImage from "../assets/Primarlogo.png";
import Primarlogo2Image from "../assets/Primarlogo-2.png";
import Primarlogo3Image from "../assets/Primarlogo-3.png";
import Sekundarlogo from "../assets/Sekundarlogo.png";
import Sekundarlogo2 from "../assets/Sekundarlogo-2.png";
import Sentrertlogo from "../assets/Sentrertlogo.png";
import PrimarlogoPosNeg from "../assets/PrimarlogoPosNeg.png";

export default function LogoPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Logo"
          lead="Statsfolvalterens nye symbol bygger på det såkalte «Lille Riksvåpen», som er en frittstående Riksløve"
        />
        <main>
          <Row className="my-5">
            <Col md={{ span: 8, offset: 2 }}>
              <h2 className="mb-5">Logofiler for nedlastning</h2>
            </Col>
            <Col md={{ span: 4, offset: 2 }}>
              <ListGroup variant="flush">
                <LinkListItem
                  title="Statsforvalteren i Agder"
                  url="/logo-agder"
                />
                <LinkListItem
                  title="Statsforvalteren i Innlandet"
                  url="/logo-innlandet"
                />
                <LinkListItem
                  title="Statsforvalteren i Møre og Romsdal"
                  url="/logo-møre-og-romsdal"
                />
                <LinkListItem
                  title="Statsforvalteren i Nordland"
                  url="/logo-nordland"
                />
                <LinkListItem
                  title="Statsforvalteren i Oslo og Viken (gjelder til 30.06.24)"
                  url="/logo-oslo-og-viken"
                />
                <LinkListItem 
                  title="Statsforvalternes Fellestjenester"
                  url="/logo-staf"
                />
              </ListGroup>
            </Col>
            <Col md={{ span: 4 }}>
              <ListGroup variant="flush">
                <LinkListItem
                  title="Statsforvalteren i Rogaland"
                  url="/logo-rogaland"
                />
                <LinkListItem
                  title="Statsforvalteren i Troms og Finnmark"
                  url="/logo-troms-og-finnmark"
                />
                <LinkListItem
                  title="Statsforvalteren i Trøndelag"
                  url="/logo-trøndelag"
                />

                <LinkListItem
                  title="Statsforvalteren i Vestfold og telemark"
                  url="/logo-vestfold-og-telemark"
                />
                <LinkListItem
                  title="Statsforvalteren i Vestland"
                  url="/logo-vestland"
                />
                <LinkListItem
                  title="Statsforvalteren i Østfold, Buskerud, Oslo og Akershus (gjelder fra 01.07.24)"
                  url="/logo-Oestfold-Buskerud-Oslo-og-Akershus"
                />
              </ListGroup>
            </Col>
          </Row>
          <div className="my-6">
            <Row className="content ">
              <Col md={{ span: 8, offset: 2 }}>
                <h2 className="mb-4">Statsforvalterens standardlogo</h2>
                <p>
                  Logoen skal kun brukes i sort eller hvitt (negativ versjon).
                  Logomaler er designet med embetsnavn på én og to linjer.
                  To-linjers logo brukes for å bedre lesbarheten på veldig små
                  logoflater (som i digitale annonser). De samme malene brukes
                  for alle språkvarianter. Statsforvalterens symbol tar
                  utganspunkt i “Lille Riksvåpen” (frittstående Riksløve) og som
                  også brukes av alle departementene, utenriksstasjoner og
                  Statsministerens kontor.
                </p>
                <p>
                  Den er satt i en sirkel som dermed danner et noe mer robust og
                  tydelig symbol.
                </p>
                <p>
                  Løvens flate er delt i 4 horisontalt og i 5 deler vertikalt.
                  Disse målenheter danner grunnlaget i sirkelstørrelse og
                  avstand til typografi og marger.
                </p>
                <p>
                  Som hovedregel skal logosymbolet alltid brukes i kombinasjon
                  med regionsnavnet. Logosymbolet skal derfor kun benyttes der
                  det er stor plassmangel, som for eksempel:
                </p>
                <ul>
                  <li>Facebook</li>
                  <li>Instagram</li>
                  <li>Twitter</li>
                </ul>
              </Col>
            </Row>
            <Image
              size="medium"
              imgUrl={LilleRiksvapenImage}
              alt="Lille Riksvåpen i sirkel"
              caption="Lille Riksvåpen i sirkel"
            />
          </div>
          <div className="mb-6">
            <Row className="content">
              <Col md={{ span: 8, offset: 2 }}>
                <h2 className="mb-4">Primærlogo</h2>
                <p>
                  Navnet «Statsforvalteren» er vårt viktigste identitetselement.
                  Navnet framheves som en tydelig del av logoen.
                </p>
                <p>Logoen har et tydelig og solid uttrykk.</p>
                <p>
                  Symbolikken i logoen, og identiteten generelt, er knyttet til
                  samme myndighetssymbolikk som departementene,
                  utenriksstasjoner og Statsministerens kontor.
                </p>
                <p>
                  Løven symboliserer nasjonal myndighet, sammen med etatens navn
                  dannes et tydelig og solid navntrekk.
                </p>
                <p>
                  Statsforvalteren sin logo skal aldri fremstå utfallende, og må
                  ha en minimumsavstand (se konstruksjon) rundt seg for å stå
                  frem som en tydelig og synlig avsender. 1X er definert som
                  5-del av høyden på riksløven. Avstand til typografien
                  (regionsnavn og ev oversettelser) er definert med antall x i
                  illustrasjonen.
                </p>
              </Col>
            </Row>
            <Image
              size="medium"
              imgUrl={PrimarlogoImage}
              alt="Sammenstilling symbol og embetsnavn"
              caption="Sammenstilling symbol og embetsnavn"
            />
            <Image
              size="medium"
              imgUrl={Primarlogo2Image}
              alt="Sammenstilling symbol og embetsnavn med språkvariant"
              caption="Sammenstilling symbol og embetsnavn med språkvariant"
            />
            <Image
              size="medium"
              imgUrl={Primarlogo3Image}
              alt="Sammenstilling symbol og embetsnavn med språkvariant"
              caption="Sammenstilling symbol og embetsnavn med språkvariant"
            />
          </div>

          <div className="mb-6">
            <Row className="content ">
              <Col md={{ span: 8, offset: 2 }}>
                <h2 className="mb-4">Sekundærlogo</h2>
                <p>
                  Sekundærlogo skal kun brukes når formatet begrenser bruken av
                  primærlogoen.
                </p>
              </Col>
            </Row>
            <Image
              size="medium"
              imgUrl={Sekundarlogo}
              alt="Sekundærlogo"
              caption="Sekundærlogo"
            />
            <Image
              size="medium"
              imgUrl={Sekundarlogo2}
              alt="Sekundærlogo med språkvarianter"
              caption="Sekundærlogo med språkvarianter"
            />
          </div>

          <div className="mb-6">
            <Row className="content ">
              <Col md={{span: 8, offset: 2}}>
                <h2 className="mb-4">Sentrert logo</h2>
                <p>Sentrert logo kan brukes i tilfeller der logoen står alene, og formatet ikke passer til primærlogoen, slik som for eksempel på en kaffekopp, eller på en avgrenset flate på en fasade.</p>
              </Col>
            </Row>

            <Image
              size="medium"
              imgUrl={Sentrertlogo}
              alt="Sentrert logo"
              caption="Sentrert logo med symbol og embetsnavn"
            />

          </div>



          <div className="mb-6">
            <Row className="content">
              <Col md={{ span: 8, offset: 2 }}>
                <h2 className="mb-4">Positiv + negativ</h2>
                <p>Logofarge er alltid sort.</p>
                <p>
                  Logoen skal også, så lenge det lar seg gjøre, plasseres på en
                  hvit/lys bakgrunn for å ivareta et seriøst, gjenkjennelig og
                  solid uttrykk.
                </p>
                <p>
                  Dersom logoen skal plasseres på en mørk bakgrunn eller et
                  bilde skal den negative versjonen av logoen brukes.
                </p>
              </Col>
            </Row>
            <Image
              size="medium"
              imgUrl={PrimarlogoPosNeg}
              alt="Primærlogo positiv og negativ"
              caption="Primærlogo positiv og negativ"
            />
          </div>
        </main>
      </article>
    </Container>
  );
}
